import styled from '@emotion/styled';
import Img from 'components/atoms/img';
import { Video } from 'components/atoms/video';
import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import sizes from 'style/sizes';
import { mq } from 'style/variables';

type GalleryLoopSlideProps = {
  type?: 'full' | 'normal';
  contents: Array<GalleryLoopSlideType>;
  rtl?: boolean;
};

export type GalleryLoopSlideType = {
  media: 'image' | 'video';
  path: string;
};

const Container = styled.div`
  margin-bottom: ${sizes.margin[209]};
  overflow: hidden;
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
  }
`;

const SliderWrapper = styled.div<GalleryLoopSlideProps>`
  position: relative;
  margin-bottom: 0;
  .slick-track {
    will-change: transform;
  }
  .slick-slide {
    width: 100%;
    max-width: ${({ type }) => (type === 'full' ? '1180' : '592')}px;
    ${mq.onlysp} {
      max-width: 100%;
    }
    > div {
      margin: 0 10px;
    }
  }
`;

const speed = 20000;
const GalleryLoopSlide: React.FC<GalleryLoopSlideProps> = props => {
  const slider = useRef<Slider>(null);

  const settings: Settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed,
    infinite: true,
    // slidesToShow: props.type === 'full' ? 1 : 2,
    // slidesToScroll: 1,
    variableWidth: true,
    rtl: props.rtl,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <Container>
      <SliderWrapper {...props}>
        <Slider {...settings} ref={slider}>
          {props.contents.map((item, idx) =>
            item.media === 'image' ? (
              <Img key={idx} filename={item.path} alt={''} />
            ) : (
              <Video key={idx} url={item.path} />
            )
          )}
        </Slider>
      </SliderWrapper>
    </Container>
  );
};

export default GalleryLoopSlide;
